module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/downloaded-file-125d7b8ac048a49cbea8b2ebc59001af.svg";